export default "__VITE_ASSET__CSbaJ70x__"